// 📄 hooks/useCredentials.ts
// Lista de credenciales del proyecto (tiempo real, filtrada por
// firestore.rules a "las propias + las compartidas") + operaciones CRUD,
// que se resuelven vía Cloud Function (ver credentialService.ts).
import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext.tsx';
import {
  CredentialInput,
  CredentialMetadata,
  createCredential,
  deleteCredential,
  subscribeCredentials,
  updateCredential
} from '../services/credentialService.ts';

export function useCredentials(projectId: string) {
  const { user } = useAuth();
  const uid = user?.uid;
  const [credentials, setCredentials] = useState<CredentialMetadata[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!projectId || !uid) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    const unsubscribe = subscribeCredentials(
      projectId,
      uid,
      (list) => {
        setCredentials(list);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [projectId, uid]);

  const create = async (data: CredentialInput) => {
    await createCredential(projectId, data);
  };

  const update = async (credId: string, data: CredentialInput) => {
    await updateCredential(projectId, credId, data);
  };

  const remove = async (credId: string) => {
    await deleteCredential(projectId, credId);
  };

  return {
    credentials,
    loading,
    error,
    createCredential: create,
    updateCredential: update,
    deleteCredential: remove
  };
}
